import { TaskGroupWithSLA } from '@commenda/types/src/service-request/types';
import {
  ServiceRequestStatus,
  TaskParty,
} from '@prisma/client';

type TaskGroupCardCountTaskForYouProps = {
  taskGroup: TaskGroupWithSLA;
  role: TaskParty;
};

const ServiceRequestTaskCountBadge = ({
  taskGroup,
  role,
}: TaskGroupCardCountTaskForYouProps) => {
  if (taskGroup.status === ServiceRequestStatus.COMPLETED) return null;

  // For now there is only ever 1 active open task, so we can hardcode the count
  const taskCount = 1;

  return (
    <div className="txt-extra-small-regular text-text-placeholder">
      {taskCount} task for you
    </div>
  );
};

export { ServiceRequestTaskCountBadge };
